import { useContext } from 'react';

import { Field, RichText, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { RcnUserContext } from 'src/context/RcnUser/RcnUserContext';

import { ComponentProps } from 'lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from 'src/components/basicContent/TextBlock/TextBlock.module.css';
import { EditorHelp } from 'src/components/layout/_EditorHelp/_EditorHelp';

type WelcomeProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		Information: Field<string>;
	};
};

export default withDatasourceCheck()<WelcomeProps>(Welcome);

function Welcome(props: WelcomeProps): JSX.Element {
	const RcnUser = useContext(RcnUserContext);
	const isEditing = IsSitecoreEditing();

	if (!RcnUser.authenticatedUserProfile && !isEditing) {
		return <></>;
	}

	return (
		<section className={`${styles.section} padX maxWidth`}>
			<EditorHelp text="Add $firstname$ in the text for their firstname to be inserted into the Title" />
			<h3 className={styles.header}>
				{isEditing ? (
					<>
						<Text field={props.fields.Title} />
					</>
				) : (
					<span>{props.fields.Title?.value?.replace('$firstname$', RcnUser.authenticatedUserProfile?.contact?.firstName ?? '')}</span>
				)}
			</h3>

			<div className={styles.info}>
				<RichText field={props.fields.Information} className={styles.richtext} />
			</div>
		</section>
	);
}
